/* STENS — Dealers data (embedded for file:// support) */
window.STENS_DEALERS_DATA = {
  "countries": {
    
    
    
    






    
    
    
    
    
    
    
    "tr": {
      "name": "Turkey",
      "code": "tr",
      "flag": "🇹🇷",
      "summary": "Turkish dealer network cover Ankara. Hot-climate damper spec validated against Mediterranean conditions.",
      "regional_office": "Autopartia",
      "regional_phone": "+90 533 075 0005",
      "regional_email": "turkiye@stenssuspension.com",
      "dealers": [
        {
          "name": "Autopartia",
          "city": "Ankara",
          "address": "Abdulkadir Geylani Cad. No:32/F Yenimahalle/OSTIM",
          "phone": "+90 533 075 0005",
          "email": "info@autopartia.com",
          "image": "https://cdn.shopify.com/s/files/1/0752/7025/8871/files/aplogo.jpg?v=1789035452",
          "specialties": [
            "ALL Cars"
          ],
          "since": 2025
        },
        
      ]
    },
    
    
    
    
    
    
    
    
    
    
    
    "ae": {
      "name": "United Arab Emirates",
      "code": "ae",
      "flag": "🇦🇪",
      "summary": "Gulf region hub with hot-climate damper validation. Specialized supercar service in Dubai and Abu Dhabi.",
      "regional_office": "STENS Middle East FZ-LLC · Dubai",
      "regional_phone": "+971 4 555 0100",
      "regional_email": "me@stens.com",
      "dealers": [
        {
          "name": "Hashtag Performance",
          "city": "Dubai",
          "address": "Sheikh Zayed Road 800, Dubai",
          "phone": "+971 4 555 0210",
          "email": "dubai@dubperf.ae",
          "specialties": [
            "Supercars",
            "Hot-climate spec"
          ],
          "since": 2026
        },
        
      ]
    },
    
    
  }
};
